import { createRoot } from "react-dom/client";

import App from "safety/App";
import "safety/index.css";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
